import { Constants } from "@app/constants/constants";
import { selectDoesUserHaveAction } from "@app/shared/state/authentication/authentication.selectors";
import { createSelector } from "@ngrx/store";

export const selectShouldHaveAccessToFI = createSelector(
  selectDoesUserHaveAction(Constants.UserActions.FIAccess),
  selectDoesUserHaveAction(Constants.UserActions.FIAManage),
  (hasViewAction, hasAdminAction) => hasViewAction || hasAdminAction,
);
